<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Quote Status"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="openNewTypesForm"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>
    <DataTable
      :value="quoteStatuses"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="contactId"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Related Accounts"
    >
      <template #header>
        <div class="table-header">Related Quote Statuses.</div>
      </template>

      <template #empty> No Related Quote Statuses. Accounts found! </template>
      <template #loading>
        Loading Related Quote Statuses. Please wait.
      </template>
      <Column field="id" header="Id" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.id ? slotProps.data.id : "" }}
        </template>
      </Column>
      <Column field="statusCode" header="Display Order" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.statusCode ? slotProps.data.statusCode : "" }}
        </template>
      </Column>
      <Column field="colourCode" header="Colour Code" :sortable="true">
        <template #body="slotProps">
          {{
            slotProps.data.colourCode && slotProps.data.colourCode.label
              ? slotProps.data.colourCode.label
              : ""
          }}
        </template>
      </Column>
      <Column field="statusName" header="Description" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.statusName ? slotProps.data.statusName : "" }}
        </template>
      </Column>
      <Column field="active" header="Active" :sortable="true">
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-pencil"
              class="p-button-success p-mb-2"
              @click="editQuoteStatuses(slotProps.data)"
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="quoteStatusesForm"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Quote Status"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteHeader">Display Order:</label>
          <InputText
            id="noteHeader"
            v-model.trim="quoteStatus.statusCode"
            required="true"
            autofocus
          />
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Color Code:</label>
          <Dropdown
            :showClear="true"
            v-model="quoteStatus.colourCode"
            :options="colourCodes"
            optionLabel="label"
            dataKey="value"
            placeholder="Select Color Code"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">Description:</label>
          <InputText
            placeholder=""
            :disabled="false"
            :autoResize="true"
            rows="6"
            v-model="quoteStatus.statusName"
          />
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Active:</label>
          <SelectButton
            v-model="quoteStatus.active"
            :options="options"
            optionLabel="label"
            optionValue="value"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="quoteStatusesForm = false"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
      </template>
    </Dialog>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px', overflowY: 'auto' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Quote Status?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteQuoteStatuses"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import QuotationService from "@/service/QuotationService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  quotationService: null,
  data: () => ({
    quoteStatusesForm: false,
    displayConfirmation: false,
    filters: {},
    quoteStatuses: null,
    quoteStatus: {},
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ],
    colourCodes: [
      { label: "Blue", value: "badge-primary" },
      { label: "Sky Blue", value: "badge-info" },
      { label: "Gray", value: "badge-secondary" },
      { label: "Green", value: "badge-success" },
      { label: "Red", value: "badge-danger" },
      { label: "Orange", value: "badge-warning" },
      { label: "White", value: "badge-light" },
      { label: "Black", value: "badge-dark" }
    ],
    requesting: false
  }),
  computed: {
    loading() {
      if (this.quoteStatuses && this.quoteStatuses[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  created() {
    this.quotationService = new QuotationService();
  },
  mounted() {
    this.getAllQuotationStatuses();
  },
  methods: {
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    async getAllQuotationStatuses() {
      this.requesting = true;
      this.quoteStatuses = await this.quotationService.getAllQuotationStatusesByHard();
      this.requesting = false;
      this.quoteStatuses.forEach(element => {
        if (element.colourCode)
          element.colourCode = this.colourCodes.find(
            code => code.value === element.colourCode
          );
      });
    },
    async getAllActiveQuotationStatusesByHard() {
      await this.quotationService.getAllActiveQuotationStatusesByHard();
    },
    openNewTypesForm() {
      this.quoteStatus = {};
      this.quoteStatusesForm = true;
    },
    openConfirmation(data) {
      this.quoteStatus = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editQuoteStatuses(data) {
      this.quoteStatus = data;
      this.quoteStatusesForm = true;
    },
    async deleteQuoteStatuses() {
      this.closeConfirmation();
      await this.quotationService.deleteQuotationStatus(this.quoteStatus.id);
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Quote status removed",
        life: 5000
      });
      this.getAllQuotationStatuses();
      this.getAllActiveQuotationStatusesByHard();
    },
    save() {
      if (this.quoteStatus.colourCode && this.quoteStatus.colourCode.value)
        this.quoteStatus.colourCode = this.quoteStatus.colourCode.value;

      if (!this.quoteStatus.id) {
        this.quotationService
          .postQuotationStatus(this.quoteStatus)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Quote status added",
              life: 5000
            });
            this.getAllQuotationStatuses();
            this.getAllActiveQuotationStatusesByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving quotation status",
              life: 5000
            });
          });
      } else {
        this.quotationService
          .putQuotationStatus(this.quoteStatus, this.quoteStatus.id)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Quote status updated",
              life: 5000
            });
            this.getAllQuotationStatuses();
            this.getAllActiveQuotationStatusesByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating quotation status",
              life: 5000
            });
          });
      }
      this.quoteStatusesForm = false;
    }
  }
};
</script>
